import axios from "axios"

import {
  STRIPE_CREATE_PAYMENT_INTENT,
  //STRIPE_UPDATE_PAYMENT_INTENT,
  STRIPE_CARD_SETUP,
  ACTION_STARTED,
  ACTION_ENDED,
  //ACTION_SUCCESS,
  ACTION_RESET,
} from "./types"
import { catchBlockError } from "./functions"

// createPaymentIntent
// updatePaymentIntent

export const createPaymentIntent = (data) => async (dispatch) => {
  try {
    dispatch({ type: ACTION_STARTED, payload: STRIPE_CREATE_PAYMENT_INTENT })
    const res = await axios.post("/api/stripe/payment_intent/create", data, {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    })
    dispatch({
      type: STRIPE_CREATE_PAYMENT_INTENT,
      payload: res.data,
    })
    dispatch({ type: ACTION_ENDED })
    return dispatch({ type: ACTION_RESET })
  } catch (error) {
    catchBlockError(error, dispatch)
  }
}

export const cancelStripeIntent = () => async (dispatch) => {
  try {
    // Kutsutaan sitä backend-reittiä, jonka loimme aiemmin
    const res = await axios.get("/api/billing/stripe/cancel_setup_intent");

    // Jos backend palauttaa päivitetyn käyttäjän (user), päivitetään se Reduxiin
    if (res.data && res.data.user) {
      dispatch({ type: "AUTH_FETCH_CURRENT_USER", payload: res.data.user });
    }

    return res.data;
  } catch (err) {
    console.error("Peruutus epäonnistui actionissa:", err);
    throw err;
  }
}

export const cardSetup = (data) => async (dispatch) => {
  try {
    dispatch({ type: ACTION_STARTED, payload: STRIPE_CARD_SETUP })
    const res = await axios.post("/api/stripe/card_setup", data, {
      headers: {
        authorization: localStorage.getItem("token"),
      },
    })
    dispatch({
      type: STRIPE_CARD_SETUP,
      payload: res.data,
    })
    dispatch({ type: ACTION_ENDED })
    return dispatch({ type: ACTION_RESET })
  } catch (error) {
    catchBlockError(error, dispatch)
  }
}

const stripeActions = {
  createPaymentIntent,
  cardSetup,
}

export default stripeActions
